import { render, staticRenderFns } from "./NewAtoutPopup.vue?vue&type=template&id=485d67a9&"
import script from "./NewAtoutPopup.vue?vue&type=script&lang=js&"
export * from "./NewAtoutPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports